import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from '../auth.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptorService implements HttpInterceptor {

	constructor(
		private authService: AuthenticationService, // ✅ inyectar el servicio
		private toastr: ToastrService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((err: HttpErrorResponse) => {

				// ✅ 401: delegar al servicio, limpia signals + storage + navega
				if (err.status === 401) {
					this.authService.logout();
					return throwError(() => err); // ✅ el observable termina correctamente
				}
				// ✅ Otros errores: mostrar toastr
				let errorMessage = '';

				if (err.error) {
					errorMessage = err.error.message || err.statusText;

					if (err.error.message === 'Modelo no válido' && Array.isArray(err.error.data)) {
						// ✅ Errores de validación campo por campo
						err.error.data.forEach((errorItem: any) => {
							this.toastr.error(
								`Campo [${errorItem.field}] ${errorItem.description}`,
								environment.appName
							);
						});

					} else if (err.error.result) {
						this.toastr.error(`${err.error.result}`, environment.appName);

					} else if (errorMessage) {
						this.toastr.error(`${errorMessage}`, environment.appName);

					} else {
						this.toastr.error(
							`Ocurrió un error al procesar la solicitud: ${JSON.stringify(err)}`,
							environment.appName
						);
					}
				}

				return throwError(() => errorMessage); // ✅ factory function
			})
		);
	}
}